class MaBeGroupedVariants extends HTMLElement {
  connectedCallback() {
    this.setAttribute('data-ready', '');
    this.abort?.abort(); this.abort = new AbortController();
    this.addEventListener('click', event => {
      const button = event.target.closest('button[data-options]');
      if (!button || button.disabled) return;
      const picker = this.closest('variant-picker');
      const values = JSON.parse(button.dataset.options);
      const form = picker.querySelector('.variant-picker__form');
      let lastInput;
      // Set every option first, then issue one native change/request for the combination.
      values.forEach((value, index) => {
        const radio = Array.from(form.querySelectorAll('fieldset input[type=radio]')).find(input => input.dataset.inputId?.startsWith(`${index + 1}-`) && input.value === value);
        const select = Array.from(form.querySelectorAll('select')).find(select => Array.from(select.options).some(option => option.dataset.inputId?.startsWith(`${index + 1}-`)));
        if (radio) { radio.checked = true; picker.updateSelectedOption(radio); lastInput = radio; }
        else if (select) { select.value = value; picker.updateSelectedOption(select); lastInput = select; }
      });
      for (const other of this.querySelectorAll('button')) other.setAttribute('aria-pressed', String(other === button));
      lastInput?.dispatchEvent(new Event('change', { bubbles: true }));
    }, {signal:this.abort.signal});
  }
  disconnectedCallback() { this.abort?.abort(); }
}
if (!customElements.get('mabe-grouped-variants')) customElements.define('mabe-grouped-variants', MaBeGroupedVariants);
